import React from 'react';

import { propExistsAndNonEmpty, createFilterObject, shuffleArray } from '../../../../../util/utils';
import { sendFreeResponseEvent } from '../../../../../api/eventsApi';
import SinglePageDefaultAnswerItem from './singlePageDefaultAnswerItem/singlePageDefaultAnswerItem';
import './singlePageDefaultAnswerIndex.scss';

class SinglePageDefaultAnswerIndex extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedFilters: this.props.selectedFilters,
            expandFreeResponse: false,
            freeResponseValue: ''
        }

        this.NoneAboveFilter = 'None of these';
        this.OtherFilter = 'Other';
        this.NoneAboveValue = -1;

        this.handleSelect = this.handleSelect.bind(this);
        this.handleDeselect = this.handleDeselect.bind(this);
        this.handleSelectOnly = this.handleSelectOnly.bind(this);
        this.isDependentRootPrompt = this.isDependentRootPrompt.bind(this);
        this.toggleDisplay = this.toggleDisplay.bind(this);
    }

    componentWillUnmount() {
        if (this.state.freeResponseValue && this.state.expandFreeResponse) {
            sendFreeResponseEvent(this.state.freeResponseValue, this.props.prompt.question, this.props.assessment);
        }
    }

    handleSelect(filter, position) {
        const promptId = this.props.prompt.id;
        const filterObj = createFilterObject(filter.tag, promptId, position);

        if (!this.isNoneFilter(filter)) {
            this.props.sendReceivedFilterEvent(filterObj);

            if (this.noneFilterSelected()) {
                if(this.props.selectedFilters.includes(this.OtherFilter)) {
                    this.props.removeFilter(this.createOtherObject());
                } else {
                    this.props.removeFilter(this.createNoneFilterObject());
                }

                this.setState({ expandFreeResponse: false });
            }

            if (this.isDependentRootPrompt()) {
                this.props.addPromptToQueue(filter.dependent);
            }

        } else {
            this.props.sendReceivedFilterEvent(filterObj);
            this.props.receiveOnlyFilter(filterObj);

            if (this.isDependentRootPrompt()) {
                this.props.resetPromptQueue();
            }

            if (filter.allowFreeResponse) {
                this.setState({ expandFreeResponse: true });
            } else {
                this.setState({ expandFreeResponse: false }); 
            }
        }
    }

    handleDeselect(deselectedFilter, position) {
        const promptId = this.props.prompt.id;
        const filterObj = createFilterObject(deselectedFilter.tag, promptId, position);
        this.props.sendReceivedFilterEvent(filterObj);

        this.props.removeFilter(filterObj);

        if (this.isDependentRootPrompt()) {
            this.props.removePromptFromQueue(deselectedFilter.dependent);
        }

        if (deselectedFilter.allowFreeResponse) {
            this.setState({ expandFreeResponse: false });
        }
    }

    handleSelectOnly(filter, position) {
        const promptId = this.props.prompt.id;
        const filterObj = createFilterObject(filter.tag, promptId, position);
        this.props.sendReceivedFilterEvent(filterObj);

        this.props.sendReceivedFilterEvent(filterObj);
        this.props.receiveOnlyFilter(filterObj);

        if (filter.allowFreeResponse) {
            this.setState({ expandFreeResponse: !this.state.expandFreeResponse });
        } else {
            this.setState({ expandFreeResponse: false });
        }
    }

    isDependentRootPrompt() {
        const promptId = this.props.prompt.id;
        return this.props.assessment.type === 'dependentOnRoot' && promptId === this.props.assessment.rootPrompt;
    }

    isNoneFilter(filter) {
        return filter.tag === this.NoneAboveFilter || filter.tag === this.OtherFilter || filter.tag === this.NoneAboveValue;
    }

    noneFilterSelected() {
        return  this.props.selectedFilters.includes(this.NoneAboveFilter) || 
                this.props.selectedFilters.includes(this.OtherFilter) ||
                this.props.selectedFilters.includes(this.NoneAboveValue);
    }

    createNoneFilterObject() {
        const promptId = this.props.prompt.id;
        const nonePosition =
        this.props.selectedFilters.indexOf(this.NoneAboveFilter) > -1
            ? this.props.selectedFilters.indexOf(this.NoneAboveFilter)
            : this.props.selectedFilters.indexOf(this.NoneAboveValue);

        const filterVal = Number.isInteger(this.props.selectedFilters[nonePosition]) ? this.NoneAboveValue : this.NoneAboveFilter;

        return createFilterObject(filterVal, promptId, nonePosition);
    }

    createOtherObject() {
        const promptId = this.props.prompt.id;
        const otherPosition =
        this.props.selectedFilters.indexOf(this.OtherFilter) > -1
            ? this.props.selectedFilters.indexOf(this.OtherFilter)
            : this.props.selectedFilters.indexOf(this.NoneAboveValue);

        const filterVal = Number.isInteger(this.props.selectedFilters[otherPosition]) ? this.NoneAboveValue : this.OtherFilter;

        return createFilterObject(filterVal, promptId, otherPosition);
    }

    toggleDisplay() {
        return this.state.expandFreeResponse ? 'show' : 'hide';
    }

    shuffle(answerOptions) {
        const lastItem = answerOptions[answerOptions.length - 1];

        if (this.isNoneFilter(lastItem)) {
            return shuffleArray(answerOptions.slice(0, answerOptions.length - 1), this.props.randomSeed).concat([lastItem]);
        }

        return shuffleArray(answerOptions, this.props.randomSeed);
    }

    render() {
        const { prompt } = this.props;

        let answers;
        if (propExistsAndNonEmpty(prompt)) {
            const items = prompt.randomize ? this.shuffle(prompt.filters) : prompt.filters;

            answers = items.map((filter, idx) => {
                return (
                    <SinglePageDefaultAnswerItem
                        key={idx}
                        position={filter.id ? filter.id - 1 : idx}
                        selectOnly={prompt.maxSelection == 1 ? true : false}
                        handleSelect={this.handleSelect}
                        handleDeselect={this.handleDeselect}
                        handleSelectOnly={this.handleSelectOnly}
                        selectedFilters={this.props.selectedFilters}
                        filter={filter}
                    />
                )
            });
        }

        return (
            <div>
                <ul className='answers-container'>
                    {answers}
                </ul>

                <textarea
                    id={this.toggleDisplay()}
                    className='free-response'
                    placeholder="Type your answer (optional)"
                    value={this.state.freeResponseValue}
                    onChange={event => this.setState({freeResponseValue: event.target.value})}
                />
            </div>
        )
    }

}

export default SinglePageDefaultAnswerIndex;